export const integrationsDirectCdiJobsJobIdSinkLogs = "/integrations/direct/cdi/jobs/:job_id/sink_logs";
